import {connect} from "react-redux";
import type {ApplicationState} from "../../../reducers";
import {CouponCode} from "../../../components/checkout/dataSummaryBox/CouponCode";
import {resetCoupon, resetCouponToast, setCoupon} from "../../../actions/coupon";

const mapStateToProps = (state: ApplicationState, _ownProps) => {
	return {
		coupon: state.coupon.coupon,
		couponErrorCode: state.coupon.couponErrorCode,
		couponSuccessCode: state.coupon.couponSuccessCode,
	};
};

const mapDispatchToProps = dispatch => {
	return {
		resetCoupon: () => dispatch(resetCoupon()),
		setCoupon: (code: string) => dispatch(setCoupon(code)),
		resetCouponToast: () => dispatch(resetCouponToast())
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(CouponCode);
